export const textQueryParamInUrl = "text";
